export const navigation = [
    {
        'id'      : 'applications',
        'title'   : 'Applications',
        'translate': 'NAV.APPLICATIONS',
        'type'    : 'group',
      'children': [
        {
          'id'   : 'dashboard',
          'title': 'Dashboard',
          'translate': 'NAV.SAMPLE.TITLE',
          'type' : 'item',
          'icon' : 'dashboard',
          'url'  : '/dashboard',
        }
        ,
        {
          'id'   : 'settings',
          'title': 'Settings',
          'translate': 'NAV.SAMPLE.TITLE',
          'type' : 'item',
          'icon' : 'settings',
          'url'  : '/settings',
        },
        {
          'id'   : 'sendmessage',
          'title': 'Send Message',
          'translate': 'NAV.SAMPLE.TITLE',
          'type' : 'item',
          'icon' : 'send',
          'url'  : '/send-message',
        },
        {
          'id' : 'inquiry',
          'title': 'Messages',
          'translate': 'NAV.SAMPLE.TITLE',
          'type': 'item',
          'icon': 'mail',
          'url': '/inquires'
        },
        {
          'id' : 'stats',
          'title': 'Stats',
          'translate': 'NAV.SAMPLE.TITLE',
          'type': 'item',
          'icon': 'bar_chart',
          'url': '/statistics'
        }
      ]
    }
];
